"use strict";
// @ts-nocheck
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
exports.__esModule = true;
var React = __importStar(require("react"));
;
function burst(_a) {
    var size = _a.size, _b = _a.color, color = _b === void 0 ? "currentColor" : _b;
    return React.createElement("svg", { width: size, height: size, viewBox: "0 0 24 24", fill: "none" },
        React.createElement("path", { d: "M10.2794 14.472L4.49994 12.5775H8.36619L8.74869 10.7452L12.1822 10.7475L13.0387 6H16.4932C18.8317 6 19.7797 6.94125 19.4294 8.88375L19.3544 9.3C19.1497 10.4317 18.6329 11.184 17.7449 11.6182C18.6247 12.0683 18.9202 12.9195 18.6989 14.1458L18.5279 15.0953C18.1859 16.9898 16.7924 18 14.5289 18H10.8727L11.8199 12.7552H10.6724L10.2794 14.472ZM14.0789 12.4117L13.3709 16.3342H14.8297C15.6952 16.3342 16.1759 15.9502 16.3394 15.0443L16.5232 14.0295C16.7317 12.8722 16.3312 12.4117 15.1964 12.4117H14.0789ZM14.9362 7.665L14.3182 11.088H15.3772C16.3432 11.088 16.9079 10.6755 17.0812 9.7155L17.1989 9.066C17.3677 8.13075 17.0182 7.665 16.1324 7.665H15.0749H14.9362Z", fill: color }));
}
exports["default"] = burst;
//# sourceMappingURL=burst.js.map